import React from 'react';
import ReceiveFilterContextProvider from "./context/ReceiveFilterContext";
import CapabilityContextProvider from "../global/context/ConfigContext";
import Column from "@amzn/meridian/column";
import Navigation, {NavigationRoutes} from "../util/Navigation";
import {RECEIVE_ROUTES} from "../util/RouteConstants";
import ReceiveOverViewContextProvider from "./context/ReceiveOverViewContext";
import ReceiveGroupByContextProvider from "./context/ReceiveGroupByContext";
import LineHaulListContextProvider from "../linehaul/context/LineHaulListContext";
import PageHeader from "../util/PageHeader";
import {PAGE_HEADERS} from "../util/Constants";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";

const Receive = ({location, history}) => {
    const {spacingInset_shorthand4} = useDeviceLayout();
    return (
        <Column spacingInset={spacingInset_shorthand4} spacing={"medium"}>
            <PageHeader {...PAGE_HEADERS.RECEIVE}/>
            <ReceiveGroupByContextProvider>
            <ReceiveOverViewContextProvider>
            <LineHaulListContextProvider>
                <Navigation routes={RECEIVE_ROUTES} location={location} history={history}/>
                <ReceiveFilterContextProvider>
                <CapabilityContextProvider>
                    <NavigationRoutes routes={RECEIVE_ROUTES}/>
                </CapabilityContextProvider>
                </ReceiveFilterContextProvider>
            </LineHaulListContextProvider>
            </ReceiveOverViewContextProvider>
            </ReceiveGroupByContextProvider>
        </Column>
    )
}

export default Receive;


// WEBPACK FOOTER //
// ./src/components/receive/Receive.js